import { Box, Typography } from "@mui/material";
import { StatusChip } from "../../../components/ui";
import { LitigationStage } from "./Areas";
import { LitigationFunnelMatter } from "../../../api/models/LitigationFunnelMatter";
import { MatterCard } from "./MatterCard";

interface Props {
  stage: LitigationStage;
  matters: LitigationFunnelMatter[];
}

export const Stage = ({ stage, matters }: Props) => {
  return (
    <Box
      sx={{
        width: 250,
        minWidth: 250,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.paper",
        p: 1,
        gap: 1,
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 1px 2px rgba(27, 30, 51, 0.04)",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          wordBreak: "break-word",
          textWrap: "auto",
          flexShrink: 0,
          minHeight: 40,
          display: "flex",
          alignItems: "flex-start",
          gap: 1,
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        <Box component="span" sx={{ flex: 1 }}>
          {stage.name}
        </Box>
        <StatusChip label={matters.length} tone="neutral" size="small" />
      </Typography>

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          mb: 1,
        }}
      >
        {matters.length > 0 ? (
          matters.map((matter, idx) => (
            <Box key={idx} sx={{ flexShrink: 0, padding: 0 }}>
              <MatterCard matter={matter} />
            </Box>
          ))
        ) : (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              textAlign: "center",
              display: "block",
              mt: 4,
              flexShrink: 0,
            }}
          >
            No Case
          </Typography>
        )}
      </Box>
    </Box>
  );
};
